import { getArticlesByTopic } from '../articles';
import { HelpTopicCard } from './HelpTopicCard';
import type { HelpTopic } from '../types';

type HelpTopicGridProps = {
    topics: HelpTopic[];
};

export function HelpTopicGrid({ topics }: HelpTopicGridProps) {
    return (
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
            {topics.map((topic) => (
                <HelpTopicCard
                    key={topic.id}
                    topic={topic}
                    articleCount={getArticlesByTopic(topic.id).length}
                />
            ))}
        </div>
    );
}
